export default "__VITE_ASSET__64755122__"